import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProgressStepper from "../visitConstant/ProgressSteppers/ProgressStepper";
import apiHelper from "../ApiHelpar/apiHelper";
import { CREACTHOSPITAL } from "../visitConstant/ApiConstant";

const AddHospital = ({ expandedView, dataEdit, setRefreshApi, RefreshApi }) => {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (dataEdit?.name) {
      setName(dataEdit?.name);
      setLocation(dataEdit?.location);
    }
  }, [dataEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !location.trim()) {
      setError("Please fill in all required fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const data = {
        ...dataEdit,
        name: name,
        location: location,
      };

      const response = await apiHelper(CREACTHOSPITAL, data);
      if (response.respInfo.code === "0") {
        const newHospital = response.respData.respMsg;

        // setError(response.respData.message);
        setName("");
        setLocation("");
        setRefreshApi(!RefreshApi);
      }
    } catch (err) {
      console.log(err);
      setError("Error adding hospital. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="justify-content-center  w-100 " style={{ maxWidth: 700 }}>
      <div className="">
        {/* <ProgressStepper currentSteps={2} /> */}
        <div className="card shadow-sm ">
          <div className="card-header ">
            <h4 className="mb-0">Add Hospital Branch</h4>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}
            {/* {success && <div className="alert alert-success">{success}</div>} */}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="hospitalName" className="form-label fw-medium">
                  Hospital Name*
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="hospitalName"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter hospital name"
                  required
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor="hospitalLocation"
                  className="form-label fw-medium"
                >
                  Location*
                </label>
                <textarea
                  rows="4"
                  type="text"
                  className="form-control"
                  id="hospitalLocation"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  placeholder="Enter hospital location"
                  required
                />
              </div>

              <div className="d-flex justify-content-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary text-light px-4"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </>
                  ) : (
                    "Add Hospital"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHospital;
